













import Observer from 'fontfaceobserver'
import { Component, Vue } from 'vue-property-decorator'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

import * as config from '@/config'
import NavItem from '@/models/NavItem'
import { FontFace } from '@/models/FontFace'
import { NavItemTypes } from '@/models/Types'

@Component({
  components: {
    Header,
    Footer,
  },
  metaInfo() {
    return {
      title: config.meta.title,
      titleTemplate: '%s | Cabin Artists',
      meta: [
        {
          name: 'description',
          vmid: 'description',
          content: config.meta.description,
        },
      ],
    }
  },
})
export default class App extends Vue {
  // data
  fontsLoaded: boolean = false
  navListHeader: NavItem[] = []
  navListFooter: NavItem[] = []
  isMenuOpen: boolean = false

  // computed
  get appClasses() : any[] {
    return [
      'container',
      {
        container__home: this.$route.path === '/',
        'container__nav--active': this.isMenuOpen,
        'fonts-loaded': this.fontsLoaded,
      },
    ]
  }

  // methods
  getNav() {
    const url = `${config.api.baseURL}${config.api.navURL}/`
    const fetchAsync = async () => (await fetch(url, config.api.fetchOptions)).json()

    fetchAsync()
      .then((navList: NavItem[]) => {
        this.navListHeader = navList.filter(item => this.isHeaderNavItem(item))
        this.navListFooter = navList.filter(item => this.isFooterNavItem(item))
      })
  }

  isHeaderNavItem(item: NavItem) : boolean {
    return item.type === NavItemTypes.MAIN || item.type === NavItemTypes.SOCIAL_MEDIA
  }

  isFooterNavItem(item: NavItem) : boolean {
    return item.type === NavItemTypes.FOOTER || item.type === NavItemTypes.EMAIL
  }

  loadFonts() {
    const fontObservers: {}[] = []

    if (sessionStorage.fontsLoaded) {
      this.fontsLoaded = true
      return
    }

    Object.keys(config.fonts).forEach(fontKey => {
      const font:FontFace = config.fonts[fontKey]
      fontObservers.push(
        new Observer(font.family.replace(/'/g, ''), {
          weight: font.weight,
          style: font.style,
        }),
      )
    })

    // optimization for repeat views
    if (fontObservers.length >= 1) {
      Promise.all(fontObservers).then(() => {
        this.fontsLoaded = true
        sessionStorage.fontsLoaded = true
      })
    }
  }

  toggleMenuOpen() {
    this.isMenuOpen = !this.isMenuOpen
  }

  // livecycle
  created() {
    this.loadFonts()
    this.getNav()
  }
}
